/// <amd-module name="VSS/Features/Directory/components/DirectoryGrid/LoadingRow" />
import { ILoadingRow, ILoadingRowProps } from "./DirectoryGrid.Props";
import { DetailsRow, IColumn } from "OfficeFabric/DetailsList";
import { Spinner } from "VSSUI/Spinner";
import * as React from "react";
import { DirectoryCSS } from "./DirectoryGridConstants";

/** Renders a loading spinner row for when the data is not yet available */
export class LoadingRow extends React.PureComponent<ILoadingRowProps> {
    public render(): JSX.Element {
        return <DetailsRow {...this.props} onRenderItemColumn={this._renderCell} />;
    }

    private _renderCell = (row: ILoadingRow, index: number, column: IColumn): JSX.Element | undefined => {
        const { columnKey, isGrouped } = this.props;

        return LoadingRow.RenderCell(row, index, column, columnKey, isGrouped);
    };

    public static RenderCell = (
        row: ILoadingRow,
        index: number,
        renderingColumn: IColumn,
        targetColumnKey: string,
        isGrouped: boolean
    ): JSX.Element | undefined => {
        if (renderingColumn.key === targetColumnKey) {
            return (
                <div className={DirectoryCSS.DIRECTORY_ROWITEM}>
                    {isGrouped && <div className={DirectoryCSS.DIRECTORY_GROUP_SPACER} />}
                    <div className="directory-row-title directory-row-spinner">
                        <Spinner className="directory-spinner" />
                        Loading...
                    </div>
                </div>
            );
        }
    };
}
